import React from 'react'
import './banner.css'

export default function ({ children, trial }) {

    return (
        <div className={`banner__container ${trial && 'banner__container--trialComplete'}`}>
            { children }
        </div>
    )

}


// WEBPACK FOOTER //
// ./src/components/Banner/index.js